import useCommonFetch from "../../../../../../hooks/useCommonFetch";
import { getAttendanceDetail, getAttendanceList } from "../../../../../../services/workspace/attendance.service";
import AttendanceTable from "../../../../../components/table/attendanceTable";

// import React from "react";
// import CommonTable from "../../../../../components/table/table";
// import useCommonFetch from "../../../../../../hooks/useCommonFetch";
// import { getAttendanceList } from "../../../../../../services/workspace/attendance.service";

// const AttendanceCard = () => {
//   const {
//     data: tableData,
//     total: totalData,
//     currentPage,
//     handlePageChange,
//     loading,
//   } = useCommonFetch(getAttendanceList, {
//     dataPath: "attendance.data",
//     totalPath: "attendance.meta.total",
//     errorMessage: "Failed to fetch attendance data",
//     debounceDelay: 300,
//     dataTransformer: (data) => {
//       return {
//         data: data.map((item) => ({
//           date: {
//             data: item.date,
//             variant: "date",
//           },
//           checkin: {
//             data: item.checkIn || "-",
//             meta: {
//               color: item.checkIn ? "green" : "red",
//             },
//             variant: "status-dot", // custom type we'll handle below
//           },
//           checkout: {
//             data: item.checkOut || "-",
//             meta: {
//               color: item.checkOut ? "green" : "red",
//             },
//             variant: "status-dot",
//           },
//           timeline: {
//             data: { checkIn: item.checkIn, checkOut: item.checkOut },
//             variant: "timeline",
//           },
//           total_hours: {
//             data: item.totalHours || "-",
//           },
//           remarks: {
//             data: item.remarks || "-",
//           },
//         })),
//         action: {},
//       };
//     },
//   });

//   const TableHeaderData = [
//     { label: "Date", key: "date" },
//     { label: "Check-in", key: "checkin" },
//     { label: "Check-out", key: "checkout" },
//     { label: "", key: "timeline" }, // visual timeline
//     { label: "Total Hrs.", key: "total_hours" },
//     { label: "Remarks", key: "remarks" },
//   ];

//   return (
//     <div className="flex flex-col bg-white rounded-md shadow-sm">
//       <div className="border-b p-4 flex justify-between items-center">
//         <h2 className="text-lg font-semibold text-blue-900">Attendance</h2>
//       </div>
//       <div className="p-4">
//         <CommonTable
//           TableHeaderData={TableHeaderData}
//           tabledata={tableData.data}
//           currentPage={currentPage}
//           totalData={totalData}
//           setCurrentPage={handlePageChange}
//           loading={loading}
//         />
//       </div>
//     </div>
//   );
// };

// export default AttendanceCard;

const AttendanceCard = ({ staff }) => {
  
  const {
    loading,
    data: tableData,
    total: totalData,
  } = useCommonFetch(getAttendanceDetail, {
    dataPath: "attendance.data",
    totalPath: "attendance.meta.total",
    errorMessage: "Failed to fetch attendance data!",
    debounceDelay: 500,
    customParams: {
      user_id: staff.id,
    },
    // Transform API response (attendance calendar) into flat rows for AttendanceTable
    dataTransformer: (data) => {
      const source = Array.isArray(data) ? data : [];

      const transformedData = source.map((item) => {
        const att = item.attendance || {};

        return {
          // base fields used by AttendanceTable
          date: item.date,
          start_time: att.start_time || "-",
          end_time: att.end_time || "-",
          totalHours: att.total_hours || "-",

          // flags for deriveRowStatus
          is_weekend: item.is_weekend,
          is_holiday: item.is_holiday,
          is_leave: item.is_leave,

          // extra display fields
          marked_by: att.marked_by || "-",
          remarks: att.remarks || "-",
        };
      });

      return { data: transformedData };
    },
  });

  const headers = [
    { name: "Date", key: "date" },
    // Connector column shows In / timeline / Out, keys handled specially
    { connecter: [{ name: "In Time" }, { name: "Out Time" }], key: "connector" },
    { name: "Total Hours", key: "totalHours", last: true },
    { name: "Status", key: "status", last: true },
    { name: "Marked By", key: "marked_by", last: true },
    { name: "Remarks", key: "remarks", last: true },
  ];

  return (
    <div className="flex flex-col gap-2 bg-white h-full">
      <div className="border-b p-4 flex justify-between items-center">
        <h2 className="text-lg font-semibold text-blue-900">Attendance</h2>
      </div>
      <div className="p-4">
        <AttendanceTable
          attendanceData={tableData?.data || []}
          getStatusStyles={getStatusStyles}
          headers={headers}
          loading={loading}
        />
      </div>
    </div>
  );
};

export const getStatusStyles = (status) => {
  switch (status) {
    case "Present":
      return { bgColor: "bg-green-500", textColor: "text-green-500" };
    case "Absent":
      return { bgColor: "bg-red-500", textColor: "text-red-500" };
    case "Half Day":
      return { bgColor: "bg-yellow-400", textColor: "text-yellow-400" };
    default:
      return { bgColor: "bg-gray-400", textColor: "text-gray-400" };
  }
};

export default AttendanceCard;
